import { jsxs, jsx } from 'react/jsx-runtime';
import { hues, white } from '@sanity/color';
import { forwardRef } from 'react';
const GroqLogo = forwardRef(function GroqLogo2(props, ref) {
  return /* @__PURE__ */jsxs("svg", {
    "data-sanity-icon": "groq-logo",
    height: "1em",
    viewBox: "0 0 304 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    ref,
    children: [/* @__PURE__ */jsx("path", {
      d: "M32 0L0 32H32V0Z",
      fill: hues.magenta[400].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M32 32H0L32 64V32Z",
      fill: hues.green[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M64 32H32V64L64 32Z",
      fill: hues.purple[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M112 0L80 32H112V0Z",
      fill: hues.green[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M112 0H80V32L112 0Z",
      fill: hues.purple[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M112 32H80L112 64V32Z",
      fill: hues.yellow[200].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M144 64L112 32V64H144Z",
      fill: hues.blue[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M80 32V64H112L80 32Z",
      fill: hues.orange[400].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M112 0V32H144L112 0Z",
      fill: hues.magenta[400].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M192 0L160 32H192V0Z",
      fill: hues.yellow[200].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M192 32H160L192 64V32Z",
      fill: hues.orange[400].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M224 32H192V64L224 32Z",
      fill: hues.green[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M192 0V32H224L192 0Z",
      fill: hues.blue[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M272 0L240 32H272V0Z",
      fill: hues.purple[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M304 32L272 64H304V32Z",
      fill: hues.magenta[400].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M272 32H240L272 64V32Z",
      fill: hues.blue[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M304 32H272V64L304 32Z",
      fill: hues.yellow[200].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M272 0V32H304L272 0Z",
      fill: hues.green[300].hex
    })]
  });
});
const GroqMonogram = forwardRef(function GroqMonogram2(props, ref) {
  return /* @__PURE__ */jsxs("svg", {
    "data-sanity-icon": "groq-monogram",
    width: "1em",
    height: "1em",
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    ref,
    children: [/* @__PURE__ */jsx("rect", {
      width: "128",
      height: "128",
      rx: "8",
      fill: hues.green[950].hex
    }), /* @__PURE__ */jsx("rect", {
      y: "32",
      width: "64",
      height: "64",
      fill: hues.green[800].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M64 32L32 64H64V32Z",
      fill: hues.magenta[400].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M64 64H32L64 96V64Z",
      fill: hues.green[300].hex
    }), /* @__PURE__ */jsx("path", {
      d: "M96 64H64V96L96 64Z",
      fill: hues.purple[300].hex
    })]
  });
});
const schemes = {
  light: [hues.red[200].hex, hues.red[300].hex, hues.red[500].hex],
  dark: [hues.gray[500].hex, hues.gray[300].hex, white.hex]
};
const SanityLogo = forwardRef(function SanityLogo2(props, ref) {
  const {
    dark,
    ...svgProps
  } = props;
  const scheme = schemes[dark ? "dark" : "light"];
  return /* @__PURE__ */jsxs("svg", {
    "data-sanity-icon": "sanity-logo",
    height: "1em",
    viewBox: "0 0 352 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    ref,
    children: [/* @__PURE__ */jsx("path", {
      d: "M311.14 57.234V80.0016H298.499V57.234",
      fill: scheme[1]
    }), /* @__PURE__ */jsx("path", {
      d: "M298.499 57.2341L319.889 20.0017H333.316L311.14 57.2341H298.499Z",
      fill: scheme[2]
    }), /* @__PURE__ */jsx("path", {
      d: "M298.499 57.2341L276.515 20.0017H290.345L305.239 45.5161L298.499 57.2341Z",
      fill: scheme[1]
    }), /* @__PURE__ */jsx("path", {
      d: "M253.839 40.9625V80.0017H241.007V47.6275L253.839 40.9625Z",
      fill: scheme[1]
    }), /* @__PURE__ */jsx("path", {
      d: "M241.007 47.5944L273.538 30.9469L268.042 21.6519L241.007 34.8633V47.5944Z",
      fill: scheme[0]
    }), /* @__PURE__ */jsx("path", {
      d: "M241.007 30.9469H221.404V20.0017H267.064L273.538 30.9469H253.839H241.007Z",
      fill: scheme[2]
    }), /* @__PURE__ */jsx("path", {
      d: "M214.047 20.0017H201.311V80.0121H214.047V20.0017Z",
      fill: scheme[2]
    }), /* @__PURE__ */jsx("path", {
      d: "M149.39 37.8712V80.0017H137.153V20.0017L149.39 37.8712Z",
      fill: scheme[1]
    }), /* @__PURE__ */jsx("path", {
      d: "M151.282 20.0017L178.231 60.9939V80.0017L137.153 20.0017H151.282Z",
      fill: scheme[2]
    }), /* @__PURE__ */jsx("path", {
      d: "M178.231 57.9129V20.0017H190.467V80.0017H178.231V57.9129Z",
      fill: scheme[1]
    }), /* @__PURE__ */jsx("path", {
      d: "M82.1168 80.9834L112.102 65.3053L108.405 55.7303L88.6644 64.9362L82.1168 80.9834Z",
      fill: scheme[0]
    }), /* @__PURE__ */jsx("path", {
      d: "M100.657 35.5422L82.1167 80.9834L72.5807 72.7745L94.6719 20.0017L100.657 35.5422Z",
      fill: scheme[1]
    }), /* @__PURE__ */jsx("path", {
      d: "M94.672 20.0017H107.312L130.69 80.0017H117.752L94.672 20.0017Z",
      fill: scheme[2]
    }), /* @__PURE__ */jsx("path", {
      d: "M25.1347 26.926C25.1347 35.2811 30.3864 40.2524 40.9004 42.8738L52.0417 45.4117C61.9923 47.6571 68.0519 53.2341 68.0519 62.3203C68.1293 66.2787 66.8194 70.1429 64.3417 73.2654C64.3417 64.2002 59.5684 59.302 48.0551 56.3568L37.1158 53.913C28.3559 51.9495 21.5946 47.3647 21.5946 37.4952C21.5485 33.6839 22.7939 29.9658 25.1347 26.926",
      fill: scheme[2]
    }), /* @__PURE__ */jsx("path", {
      d: "M57.4954 60.0957C62.2475 63.0827 64.3311 67.2602 64.3311 73.255C60.3977 78.2054 53.4875 80.9834 45.3655 80.9834C31.6941 80.9834 22.1262 74.3725 20 62.8842H33.1292C34.8196 68.1584 39.2952 70.6022 45.2698 70.6022C52.5626 70.6022 57.4104 66.7798 57.506 60.0748",
      fill: scheme[1]
    }), /* @__PURE__ */jsx("path", {
      d: "M31.9598 39.3124C29.7898 38.0455 28.0095 36.225 26.8079 34.0442C25.6062 31.8634 25.028 29.4036 25.1347 26.926C28.93 22.0174 35.5318 19.02 43.5794 19.02C57.506 19.02 65.5643 26.2472 67.5523 36.4195H54.9227C53.53 32.409 50.0431 29.2863 43.6858 29.2863C36.8926 29.2863 32.2575 33.1715 31.9917 39.3124",
      fill: scheme[1]
    })]
  });
});
const SANITY_MONOGRAM_COLOR = {
  bg1: hues.red[500].hex,
  bg2: hues.red[200].hex,
  fg: white.hex
};
const SanityMonogram = forwardRef(function SanityMonogram2(props, ref) {
  const {
    color = SANITY_MONOGRAM_COLOR,
    ...restProps
  } = props;
  return /* @__PURE__ */jsxs("svg", {
    "data-sanity-icon": "sanity-monogram",
    width: "1em",
    height: "1em",
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...restProps,
    ref,
    children: [/* @__PURE__ */jsx("rect", {
      width: "128",
      height: "128",
      rx: "8",
      fill: color.bg1
    }), /* @__PURE__ */jsx("path", {
      d: "M39.423 33.163C39.423 44.1615 46.3363 50.7056 60.1768 54.1564L74.843 57.4972C87.9418 60.453 95.9186 67.7945 95.9186 79.7554C96.0205 84.9662 94.2961 90.0531 91.0345 94.1635C91.0345 82.2301 84.751 75.7822 69.595 71.9052L55.1948 68.6882C43.6633 66.1035 34.7629 60.0681 34.7629 47.0761C34.7022 42.0589 36.3416 37.1644 39.423 33.163",
      fill: color.fg
    }), /* @__PURE__ */jsx("path", {
      d: "M82.0221 76.827C88.2776 80.759 91.0206 86.2582 91.0206 94.1497C85.8426 100.666 76.7462 104.323 66.0545 104.323C48.0576 104.323 35.4626 95.6207 32.6637 80.4977H49.9468C52.172 87.4406 58.0636 90.6576 65.9285 90.6576C75.5287 90.6576 81.9102 85.6258 82.0361 76.7995",
      fill: color.bg2
    }), /* @__PURE__ */jsx("path", {
      d: "M48.4075 49.4682C45.551 47.8004 43.2074 45.404 41.6256 42.5332C40.0437 39.6624 39.2826 36.4244 39.4231 33.1629C44.4191 26.7013 53.1096 22.7556 63.7034 22.7556C82.0362 22.7556 92.6439 32.2693 95.2609 45.66H78.6355C76.8022 40.3807 72.2121 36.27 63.8434 36.27C54.9009 36.27 48.7993 41.3843 48.4495 49.4682",
      fill: color.bg2
    })]
  });
});
export { GroqLogo, GroqMonogram, SanityLogo, SanityMonogram };
//# sourceMappingURL=index.js.map
